// @ts-nocheck - FormStatic/formatter
import React from 'react';
import KwPanel from '../../common/KwPanel';
import { NavLink } from 'react-router-dom';
import FormStatic from '../../common/FormStatic';
import { CommaNumber_NoDecimal } from '../../../util/formatter';
import FormattedDate from '../../common/FormattedDate';
import TransactionStatusBadge from './TransactionStatusBadge';
import GameLink from '../../common/links/GameLink';
import UserLink from '../../common/links/UserLink';
import { useTranslation } from 'react-i18next';

export interface MovedTransactionDetailsProps {
  transaction: any;
  currentUser: any;
}

const MovedTransactionDetails = ({
  transaction,
  currentUser,
}: MovedTransactionDetailsProps) => {
  const { t } = useTranslation();
  return (
    <KwPanel className="mb-4">
      <header className="mb-2">
        <h2 className="no-margin ">{t('Moved transaction details')}</h2>
      </header>
      <div className="row">
        <div className="col">
          <FormStatic label={t('SKU')}>
            <GameLink
              gameId={transaction.gameId}
              skuId={transaction.skuId}
              gameTitle={transaction.gameTitle}
              skuName={transaction.skuName}
              key={transaction.moveTransactionId}
              currentUser={currentUser}
            />
          </FormStatic>
          <FormStatic label={t('Source pool')}>
            <NavLink
              to={`/settings/workflow/${transaction.sourceKeyWorkflowId}`}
            >
              {transaction.sourceKeyWorkflowName}
            </NavLink>
          </FormStatic>
          <FormStatic label={t('Destination pool')}>
            <NavLink
              to={`/settings/workflow/${transaction.destinationKeyWorkflowId}`}
            >
              {transaction.destinationKeyWorkflowName}
            </NavLink>
          </FormStatic>
          <FormStatic label={t('Total keys')} className="num no-wrap">
            {transaction.numberOfKeys >= 0
              ? CommaNumber_NoDecimal(transaction.numberOfKeys)
              : ''}
          </FormStatic>
          <FormStatic label={t('Moved by')}>
            <>
              <UserLink id={transaction.userId} name={transaction.user} />,{' '}
              {transaction.userCompany}
            </>
          </FormStatic>
        </div>
        <div className="col">
          <FormStatic label={t('Date moved')}>
            <FormattedDate value={transaction.creationDate} variant="noHtml" />
          </FormStatic>
          <FormStatic label={t('Status')}>
            <TransactionStatusBadge
              success={transaction.success}
              partialSuccess={transaction.partialSuccess}
              message={transaction.message}
              status={transaction.status}
            />
          </FormStatic>
          <FormStatic label={t('Description')}>
            {transaction.description}
          </FormStatic>
          <FormStatic label={t('Message')}>{transaction.message}</FormStatic>
        </div>
      </div>
    </KwPanel>
  );
};

export default MovedTransactionDetails;
